<template>
  <div
    id="up-nav-support-card"
    class="flex flex-col p-4 w-60 gap-3 rounded bg-slate-100"
  >
    <div class="flex flex-row items-center justify-between">
      <p class="up-nav-support-card__heading-text font-semibold">
        {{ headingText }}
      </p>
      <div
        class="flex items-center justify-center bg-violet-100 p-2.5 leading-[0] rounded-full"
      >
        <div class="up-nav-support-card__icon">
          <Icon name="material-symbols:help-outline" size="1.5rem" />
        </div>
      </div>
    </div>
    <div>
      <p class="up-nav-support-card__body-text text-xs">{{ bodyText }}</p>
    </div>
    <div class="up-nav-support-card__contact-button">
      <PrimaryButton
        variant="secondary"
        data-target="contact helpdesk"
        custom-class="px-1.5 justify-self-start"
        @click="emit('contactButtonClick')"
      >
        <p
          class="up-nav-support-card__contact-button-text text-xs text-slate-700 font-semibold"
        >
          {{ contactButtonText }}
        </p>
      </PrimaryButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import PrimaryButton from "~/components/shared/primary-button/PrimaryButton.vue";

defineProps<{
  headingText: string;
  bodyText: string;
  contactButtonText: string;
}>();

const emit = defineEmits<{
  contactButtonClick: [];
}>();
</script>
